<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/SocialMediaInfo">ขอเปลี่ยนแปลงข้อมูล Soial Media</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            Line ID
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <!-- Mobile -->
            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/SocialMediaInfo">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
                    style="font-family: DB Heavent; color: #0057a8">
                    แก้ไข Line ID
                </div>
            </div>
            <!-- Mobile -->
            <div class="col">
                <div class="title d-none d-lg-block border-bottom" style="font-family: DB Heavent; color: #0057a8">
                    Line ID
                </div>
                <div class="pb-3 pb-lg-3">
                    <div class="mt-4 mt-lg-2">
                        <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
                            ข้อมูลเดิม
                        </div>
                    </div>
                    <div class="d-lg-flex align-items-center" style="font-family: monospace;">
                        <div class="blue-1 fs-6 mt-1 mt-lg-1">{{ Data.OldLineID }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="font-family form-group fs-5 mb-2">
                            <label class="field a-field page__field">
                                เปลี่ยนเป็น<span class="required">*</span> :
                                <input v-model.trim="Data.NewLineID" type="text"
                                    class="field__input a-field__input fs-6" style="font-family: monospace;"
                                    maxlength="100" @input="handleInput"
                                    :class="{ 'invalid': !isValid && Data.NewLineID !== '' }" />
                            </label>
                            <span v-if="(!isValid
                                && Data.NewLineID !== '')
                                || (Data.OldLineID !== ''
                                    && Data.NewLineID !== ''
                                    && Data.NewLineID.toLowerCase() === Data.OldLineID.toLowerCase())"
                                class="error-message">
                                Invalid LINE ID
                            </span>

                        </div>
                    </div>
                </div>
                <div class="row mb-3 mt-2">
                    <div class="col-6 col-lg-6">
                        <button type="button" class="btn btn-light btn-cancel font-family d-inline-block"
                            @click="ChechCreateJob('/SocialMediaInfo')">
                            ย้อนกลับ
                        </button>
                    </div>
                    <div class="col-6 col-lg-6 text-right">
                        <button type="button" class="btn btn-continue font-family d-inline-block" @click="EnterNext()">
                            ดำเนินการต่อ
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>
<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';
import { ref } from 'vue';

export default {
    name: "EditLineID",
    components: {
        Menu,
        LoadingBs5,
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();
        this.BindingData();
        
        this.Data.OldLineID = this.Data.OldLineID == null ? '' : this.Data.OldLineID;
        this.Data.NewLineID = this.Data.NewLineID == null ? '' : this.Data.NewLineID;
    },
    data() {
        return {
            Loading: true,
            IsEditLineID: false,
            Data: {
                OldLineID: '',
                NewLineID: '',
            },
            isValid: ref(true)
        }
    },
    methods: {
        EnterNext() {
            this.ValidateLineId();

            if ((this.Data.NewLineID.trim() !== '' && !this.isValid)
                || (this.Data.NewLineID.toLowerCase() === this.Data.OldLineID.toLowerCase())) {
                Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">Invalid LINE ID</lable>',
                });
            }
            else if (this.Data.NewLineID.trim() == '') {
                Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุ Line ID</lable>',
                });
            } else {
                this.$store.state.SocialMediaInfo.LineID.IsEditLineID = true;
                this.$store.state.SocialMediaInfo.LineID.Data.NewLineID = this.Data.NewLineID;

                this.$router.push('/SocialMediaInfo');
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        BindingData() {
            this.IsEditLineID = this.$store.state.SocialMediaInfo.LineID.IsEditLineID;
            this.Data.OldLineID = this.$store.state.SocialMediaInfo.LineID.Data.OldLineID;
            this.Data.NewLineID = this.$store.state.SocialMediaInfo.LineID.Data.NewLineID;
        },
        ChechCreateJob(to) {
            this.Authorization();
            this.$router.push(to);
        },
        ClearData() {
            this.$store.state.SocialMediaInfo.LineID.IsEditLineID = false;
            this.$store.state.SocialMediaInfo.LineID.Data.NewLineID = '';
        },
        handleInput(event) {
            this.Data.NewLineID = event.target.value.toLowerCase();
            this.ValidateLineId();
        },
        ValidateLineId() {
            const regex = /^[a-zA-Z0-9._-]{1,20}$/;
            this.isValid = regex.test(this.Data.NewLineID);
        },
    },
};
</script>

<style scoped>
.font-family-bla {
    font-family: "DB Heavent";
}

.invalid {
    border-color: red;
}

.error-message {
    color: red;
}
</style>